import { createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual } from '@comeon/utility';

export const createDeepEqualityCheckSelector = createSelectorCreator(defaultMemoize, {
	equalityCheck: isEqual
	// resultEqualityCheck: isEqualWithLogs,
});
